//import axios from 'axios'
export default {
    namespaced: true,
    state: {
		name: 'Help',
		icon: 'mdi-help',
        items: [
			{ title: 'API', icon: 'mdi-api', items: [
					{ title: 'Ціна нового авто в салонах', icon: 'mdi-train-car-flatbed-car', to: { name: 'HelpVehicleAveragePriceShowroom' } }
				],
			},
		],
    },
    actions: {
		/* load (context) {
			return axios.get(context.getters.endpoint).then(response => {
				//console.log(this.$options.name, 'onSearch','response.data', response.data)
				context.commit('items', response.data)
			}, error => {
				console.log(error)
			})
		}, */
    }
}